import { T }             from 'defa-object';
import ControlModule     from 'scripts/poppet/control-module';
import { SingleEvent }   from 'scripts/utils/single-event';
import { Program }       from 'scripts/utils/program';
import { WeeklyProgram } from 'scripts/utils/weekly-program';
import template          from 'templates/controlPickupTimes.jst.html';
import { Vue }           from 'vue/defavue';
import vueTemplate       from './view-control-pickup-times-view.vue.html';


const selectors = {
	toggleButton: '[data-toggle=expand-spoiler]',
	region: '[data-region=pickup-times-container]',
};

const days = [
	'MONDAY',
	'TUESDAY',
	'WEDNESDAY',
	'THURSDAY',
	'FRIDAY',
	'SATURDAY',
	'SUNDAY',
];

const dayChoices        = [
	{ value: 'MONDAY',    titleContext: 'DateTime', title: 'Mon' },
	{ value: 'TUESDAY',   titleContext: 'DateTime', title: 'Tue' },
	{ value: 'WEDNESDAY', titleContext: 'DateTime', title: 'Wed' },
	{ value: 'THURSDAY',  titleContext: 'DateTime', title: 'Thu' },
	{ value: 'FRIDAY',    titleContext: 'DateTime', title: 'Fri' },
	{ value: 'SATURDAY',  titleContext: 'DateTime', title: 'Sat' },
	{ value: 'SUNDAY',    titleContext: 'DateTime', title: 'Sun' }
];

const preheatingOptions = [
	{ value: 0, title: 'Auto', titleContext: 'PickupTimes' },
	{ value: 1, title: '1 hr', titleContext: 'PickupTimes' },
	{ value: 2, title: '2 hr', titleContext: 'PickupTimes' },
	{ value: 3, title: '3 hr', titleContext: 'PickupTimes' },
	{ value: 4, title: '4 hr', titleContext: 'PickupTimes' },
];
const actionOptions     = [
	{ value: 'on', title: 'On', titleContext: 'PickupTimes' },
	{ value: 'saving', title: 'Saving', titleContext: 'PickupTimes' },
	{ value: 'off', title: 'Off', titleContext: 'PickupTimes' }
];

const RECURRING = 'RECURRING';
const SINGLE = 'SINGLE';

export const ControlPickupTimesView = ControlModule.extend( {
	template,
	expandedNavState  : 'unit:control:pickupTimes',
	compressedNavState: 'unit:control:overview',
	
	ui: {
		region: selectors.region,
		toggle: selectors.toggleButton,
	},
	
	events: {
		'click @ui.toggle'         : 'onClickToggle',
	},
	className() {
		return this._getClassName( 'control-pickup-times' );
	},
	
	onDomRefresh() {
		let self   = this;
		let region = this.ui.region[ 0 ];
		console.log( region );
		
		let pickupTimesComponent = new Vue( {
			template: vueTemplate,
			bb() {
				return {
					model: self.model
				};
			},
			data() {
				return {
					dayChoices,
					preheatingOptions,
					actionOptions,
					weeklyProgram: [],
					editingIndex : null,
					editingObject: null,
				};
			},
			watch: {
				'model.weeklyProgram': function ( newAttribute ) {
					this.weeklyProgram = JSON.parse(JSON.stringify(_.sortBy(newAttribute, 'time')));
				}
			},
			computed: {
				
				canAddMore() {
					return this.weeklyProgram.length < this.model.maxCount;
				},
				programs() {
					return this.weeklyProgram.concat(this.model.singleEvents);
				},
				nextPickup() {
					const weeklyPrograms = this.weeklyProgram
										 .filter( p => p.enabled )
										 .map( p => WeeklyProgram.fromApi( p ) );
					const singleEvents = this.model.singleEvents
						.filter(p => p.enabled)
						.map(p => new SingleEvent(new Date(p.date)));
					
					//TODO: this will be problematic in the future, when 'selected timezone' should be taken into account.
					const now = new Date();
					return Program.nextTime( weeklyPrograms.concat(singleEvents), now );
				},
				editingType() {
					if (!this.editingObject) {
						return null;
					}
					if (this.editingObject.days === undefined) {
						return SINGLE;
					}
					return RECURRING;
				}
			},
			methods : {
				
				// TODO: remove this parsing when figuring out how this variable gets converted to a string. Pobably something with the vue element.
				onChangePreheat(){
					this.editingObject.preheating = parseInt(this.editingObject.preheating);
					console.log(this.editingObject);
				},
				
				addRow() {
					this.editingObject = { preheating: 0, time: '12:00', days: [], enabled: true, hour:12, minute: 0 };
					this.editingIndex  = this.weeklyProgram.length;
				},
				deleteRow(index) {
					if ( index < this.weeklyProgram.length ) {
						this.weeklyProgram.splice( index, 1 );
						this.$emit( 'save', this.weeklyProgram );
					}
				},
				
				cancelEditing() {
					this.editingObject = null;
					this.editingIndex  = null;
				},
				
				saveRow() {
					let clock = this.editingObject.time.split(':');
					this.editingObject.hour = parseInt(clock[0]);
					this.editingObject.minute = parseInt(clock[1]);
					if ( this.editingIndex === this.weeklyProgram.length ) {
						this.weeklyProgram.push( this.editingObject );
					} else {
						Object.assign( this.weeklyProgram[ this.editingIndex ], this.editingObject );
					}
					this.cancelEditing(); // TODO! Should this be sent as a success callback to save so that the edit module is not closed if the save fails?
					this.$emit( 'save', this.weeklyProgram  );
				},
				
				editRow( index ) {
					this.editingIndex  = index;
					this.editingObject = Object.assign( {}, this.weeklyProgram[ index ] );
				},
				
				updateTime( index, value ) {
					this.editingObject.hour   = value;
					this.editingObject.minute = value;
				},
				
				daysDisplay( dayArray ) {
					return (dayArray || []).concat()
								   .map( day => { return days.indexOf( day ) + 1; } )
								   .sort()
								   .map( dayIndex => T.shortDayName( dayIndex ) )
								   .join( ', ' );
				},
				
				changeState(index){
					this.weeklyProgram[index].enabled = !this.weeklyProgram[index].enabled;
					this.$emit( 'save', this.weeklyProgram);
				},
				
				preheatingName( id ) {
					if ( 0 === id ) {
						return this.tc( 'PickupTimes', 'Auto' );
					}
					return this.tc( 'PickupTimes', id + ' hr' );
				}
			},
			created() {
				this.weeklyProgram = JSON.parse(JSON.stringify(_.sortBy(this.model.weeklyProgram, 'time')))
			}
		} );
		
		pickupTimesComponent.$mount( region );
		pickupTimesComponent.$on( 'save', ( attribute ) => {
			let self = this;
			self.model.set('isValidData', false);
			let payload = this.model.attributeToReuqestPayload(attribute);
			try {
				this.model.save(payload, {
					patch: true,
					isSaving: true,
					success: function() {
						console.log( Object.keys(attribute)[0] +' was succesfully saved!' );
					},
					error: function(model, response) {
						console.error( Object.keys(attribute)[0] + ' failed saving with error: ' + response.responseJSON.message );
					}
				});
			} catch ( err ) {
				console.error( err );
				setTimeout( () => this.idle(), 1000 );
			}
		} );
	}
} );

export default ControlPickupTimesView;
